import { IController } from 'angular';
import * as _ from 'lodash';
import { ImSchool } from 'Src/ng2/shared/services/im-models/im-school';
import { CsvExporterService } from '../../../../../../../../ng2/shared/services/csv-exporter/csv-exporter.service';
import { ICourseDiff } from '../../../../../../../../ng2/shared/typings/interfaces/course-diff.interface';
import { IGapPlan } from '../../../../../../../../ng2/shared/typings/interfaces/gap-plan.interface';
import { SpinnerModal } from './../../../../../../../shared/modals/status-spinner/status-spinner.service';
import { WizardUtils } from './../../../../../../../shared/services/wizard-utils/wizard-utils.service';

export class DoFinalCheckStepCtrl implements IController {
  static $inject: string[] = [
    '$scope',
    'ImSchool',
    'CourseDiff',
    'GapPlan',
    'WizardUtils',
    'SpinnerModal',
    'CsvExporter',
    'ErrorModal',
  ];

  private currentStudents;
  private school;
  private currentTermYear;
  private starsInstructions;

  public filteredFlattenedStudents;
  public buckets;
  public options;
  public plurals;

  constructor(
    public $scope,
    private ImSchool: ImSchool,
    private CourseDiff: ICourseDiff,
    private GapPlan: IGapPlan,
    private wizardUtils: WizardUtils,
    private spinnerModal: SpinnerModal,
    private csvExporter: CsvExporterService,
    private ErrorModal,
  ) {}

  $onInit(): void {
    this.wizardUtils.startListeningAndLoad(this);
  }

  setUi(): void {
    const columnKeyMapper = {
      studentsWithCredIssues: ['cohort', 'hasPotentialCreditIssuesOnCurrProgram'],
      studentsWithPlansBeyonGradDate: ['cohort', 'hasGapPlansPastPlannedGradDate', 'gapPlansSummary'],
      studentsWithPendingCourseDiffs: ['cohort', 'pendingCourseAdditions', 'pendingCourseDrops'],
      studentsWithPendingGapPlans: ['cohort', 'pendingCourseAdditionsWithoutSection'],
    };

    this.currentStudents = this.wizardUtils.getFilteredFlattenedStudents();
    this.school = this.wizardUtils.getCurrentSdcSchool();
    this.currentTermYear = this.ImSchool.getCurrentTermYear(this.school);
    this.buckets = this.generateFilteredStudentIdBuckets();
    this.starsInstructions =
      'https://docs.google.com/document/d/1U3cKMJlpaXOOnGi5fZB2gZQa4XgukRnkCov1IIsM2qM/edit?usp=sharing';

    _.each(this.buckets, (value, key) => {
      this.buckets[key].count = value.length;
      this.buckets[key].options = { columnKeys: columnKeyMapper[key] };
    });

    this.plurals = {
      s: {
        0: "s'",
        1: "'s ",
        other: "s'",
      },
      thisCap: {
        0: ' These students',
        1: ' This student',
        other: 'These students',
      },
      this: {
        0: ' these students',
        1: ' this student',
        other: 'these students',
      },
      has: {
        0: 'students have',
        1: 'student has',
        other: 'students have',
      },
    };
  }

  private generateFilteredStudentIdBuckets() {
    const studentsWithCredIssues = [];
    const studentsWithPlansBeyonGradDate = [];
    const studentsWithPendingCourseDiffs = [];
    const studentsWithPendingGapPlans = [];
    _.each(this.currentStudents, (student: any) => {
      const {
        studentId,
        hasPotentialCreditIssuesOnCurrProgram,
        hasGapPlansPastPlannedGradDate,
        pendingCourseAdditions,
        pendingCourseDrops,
        pendingCourseAdditionsWithoutSection,
      } = student;
      // If `All` is selected from dropdown, all students fall `inCohort`
      if (hasPotentialCreditIssuesOnCurrProgram) studentsWithCredIssues.push(studentId);
      if (hasGapPlansPastPlannedGradDate) studentsWithPlansBeyonGradDate.push(studentId);
      if (pendingCourseAdditions.length > 0 || pendingCourseDrops.length > 0) {
        studentsWithPendingCourseDiffs.push(studentId);
      }
      if (pendingCourseAdditionsWithoutSection.length > 0) studentsWithPendingGapPlans.push(studentId);
    });

    return {
      studentsWithCredIssues,
      studentsWithPlansBeyonGradDate,
      studentsWithPendingCourseDiffs,
      studentsWithPendingGapPlans,
    };
  }

  public generateCourseDiffCsv(): void {
    this.spinnerModal.activateSpinner('Generating Export');
    this.csvExporter
      .createCourseDiffCsv(this.school)
      .then((csvString: string) => {
        const currentDateAndTime = moment().format('MM-DD-YYYY hmma');
        const fileName = `STARS Course Upload ${this.currentTermYear} ${currentDateAndTime}.csv`;
        const docType = 'text/csv;charset=utf-8';
        this.csvExporter.exportCsv(csvString, fileName, docType);
        this.spinnerModal.deactivateSpinner();
      })
      .catch(err => {
        this.spinnerModal.deactivateSpinner();
        this.ErrorModal.show('Unable to complete CSV export', err);
      });
  }
}
